import { apiClient } from './client'
import { log } from '../../logger'
import { returnMock } from './mock'
import { Integration } from '../../pages/integrations-marketplace/types'

export interface MarketplaceIntegrationRequest {
  integrationName: string
  email: string
  name: string
  sites: string
  additionalNotes?: string
}

export async function GetMarketplaceIntegrations(
  isMockUpEnabled: boolean,
): Promise<Integration[]> {
  const url = '/marketplace_integrations'
  
  log('fetching marketplace integrations', { url })
  
  if (isMockUpEnabled) {
    return returnMock([])
  }
  
  const response = await apiClient<Integration[]>(url, {
    method: 'GET',
  })
  
  if (!response || !Array.isArray(response)) {
    return []
  }
  
  // Filter out specific integrations (case-insensitive) for temporary
  const excludedNames = ['Park Champ', 'istall', 'greystar', 'Flash Parking']
  const filtered = response.filter(
    (integration) => !excludedNames.some(
      (excluded) => integration.name?.toLowerCase() === excluded.toLowerCase()
    )
  )
  
  // Sort alphabetically by name (case-insensitive)
  const sorted = filtered.sort((a, b) => {
    const nameA = (a.name || '').toLowerCase()
    const nameB = (b.name || '').toLowerCase()
    return nameA.localeCompare(nameB)
  })
  
  return sorted
}

export async function SendMarketplaceIntegrationRequest(
  request: MarketplaceIntegrationRequest,
  isMockUpEnabled: boolean,
): Promise<{ success: boolean; message: string }> {
  const url = '/marketplace_integrations/inquiry'
  
  if (isMockUpEnabled) {
    return returnMock({ success: true, message: 'Email has been sent' })
  }
  
  return apiClient<{ success: boolean; message: string }>(url, {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

